import { Color, ColorDynamic } from '@superdispatch/ui';
import { SidebarContainer, SidebarMenuItem } from '@superdispatch/ui-lab';
import { Sidebar } from 'shared/layout/Sidebar';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useOnboardingPacketsCount } from 'shared/modules/onboarding-packets/data/OnboardingPacketsAPI';

const SidebarBadge = styled.div`
  min-width: 16px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: center;
  padding-left: 4px;
  padding-right: 4px;
  border-radius: 100px;

  color: ${ColorDynamic.Dark500};
  background-color: ${ColorDynamic.Silver400};

  &[data-variant='primary'] {
    color: ${Color.White};
    background-color: ${ColorDynamic.Blue300};
  }

  &[data-variant='danger'] {
    color: ${Color.White};
    background-color: ${ColorDynamic.Red300};
  }
`;

export function OnboardingPacketsLayout() {
  const navigate = useNavigate();
  const statusMatch = useMatch(`/onboarding-packets/:status`);
  const status = statusMatch?.params.status;
  const { data: counts } = useOnboardingPacketsCount();

  const notSubmittedCount = counts?.pending ?? 0;

  return (
    <SidebarContainer
      sidebar={
        <Sidebar title="Onboarding">
          <SidebarMenuItem
            selected={!status}
            action={
              counts && (
                <SidebarBadge data-variant="primary">
                  {counts.total}
                </SidebarBadge>
              )
            }
            onClick={() => navigate('/onboarding-packets')}
          >
            All
          </SidebarMenuItem>
          <SidebarMenuItem
            selected={status === 'not-submitted'}
            action={
              counts && (
                <SidebarBadge
                  data-variant={notSubmittedCount > 0 ? 'danger' : undefined}
                >
                  {notSubmittedCount}
                </SidebarBadge>
              )
            }
            onClick={() => navigate('/onboarding-packets/not-submitted')}
          >
            Not Submitted
          </SidebarMenuItem>
          <SidebarMenuItem
            selected={status === 'pending'}
            action={counts && <SidebarBadge>{counts.submitted}</SidebarBadge>}
            onClick={() => navigate('/onboarding-packets/pending')}
          >
            Pending Review
          </SidebarMenuItem>
          <SidebarMenuItem
            selected={status === 'accepted'}
            action={counts && <SidebarBadge>{counts.accepted}</SidebarBadge>}
            onClick={() => navigate('/onboarding-packets/accepted')}
          >
            Accepted
          </SidebarMenuItem>
          <SidebarMenuItem
            selected={status === 'not-accepted'}
            action={
              counts && <SidebarBadge>{counts.not_accepted}</SidebarBadge>
            }
            onClick={() => navigate('/onboarding-packets/not-accepted')}
          >
            Not Accepted
          </SidebarMenuItem>
        </Sidebar>
      }
    >
      <Outlet />
    </SidebarContainer>
  );
}
